import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "assets/css/grid_table.css";
import moment from "moment";
import numeral from "numeral";
import Select from "react-select";
import { getDataApi, saveApi, loadApi } from "services/appApi";

const ShipmentSummary = () => {
  let emptyRow = {
    ship_confirm_date: "",	
    estimated_arrival_date: "",	
    delivery_number: "",	
    order_number: "",	
    item_number: "",	
    ecommerce_flag: null,	
    ship_to_city: "",	
    ship_to_state: "",	
    ship_to_zip: "",	
    ship_to_country: "",	
    shipment_quantity: "",	
    shipment_quantity_uom: "",	
    gross_weight_lb: "",	
    gross_volume: "",	
    gross_volume_cm:"",
    sales_channel:""
  };
  
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [globalFilter2, setGlobalFilter2] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [code, setCode] = useState([]);
  const [orgCode, setOrgCode] = useState({label: "CO", value: "CO"})
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [orgName, setOrgName] = useState("203");
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [details, setDetails] = useState({});
  const [expandedRowId1, setExpandedRowId1] = useState([]);
  const [components, setComponents] = useState({});
  const [itemNumber, setItemNumber] = useState("");
  const [ecommerceFlag, setEcommerceFlag] = useState("");
  const [shipmentQuantity, setshipmentQuantity] = useState("");
  const toast = useRef(null);
  const dt = useRef(null);
  const pageRows = 200;
  const rowsPerPageOptions = [200, 250, 300, 350];
  const dt1 = useRef(null);
  const dt2 = useRef(null);

  useEffect(() => {
      const fetchCode = async () => {
        try {
          let res = await loadApi("","/api/shipAuditData/getUsStateCodes");
          if (res) {
            let successFlag = res.data[0];
            console.log("Response: ",res);
            console.log("Success Flag",successFlag);
            if (successFlag === "Y" && Array.isArray(res.data[1])) {
              const options= res.data[1].map((item)=>({
                label: item.geography_name,
                value: item.geography_name
              }))
              setCode(options)
            } 
          }
        } catch (err) {
          console.log(err);
        }
      };
      fetchCode();
    }, []);

  useEffect(() => {
    const fetchData = async () => {
      const yesterday = moment().subtract(1, "days").set({
        hour: 7,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      //let formattedStartDate = yesterday.format("yyyy-MM-DD");1/1/2024
      let formattedStartDate =("2024-01-01")
      setStartDate(formattedStartDate);

      const tomorrow = moment().add(0, "days").set({
        hour: 6,
        minute: 59,
        second: 0,
        millisecond: 0,
      });
      //let formattedEndDate = tomorrow.format("yyyy-MM-DD");12/31/2024
      let formattedEndDate = ("2024-12-31");
      setEndDate(formattedEndDate);
    };

    fetchData();
  }, []);

  const handleLoadData = async () => {

    const p_param = {
      p_org_id: orgName,
      p_ship_to_state_code: orgCode.value,
      p_start_date: startDate,
      p_end_date: endDate
    };
    console.log(p_param);
    try {
      setIsLoading(true);
      const response = await loadApi(p_param, "api/shipAuditData/getShipAuditDatasumm");
      console.log("Fetched Data:", response.data);
      console.log(response.data[0]);
      console.log(response.data[1]);
      if (response.data.length > 0) {
        let successFlag = response.data[0];
        if (successFlag === "Y") {
          toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
          console.log("success=Y");
          setRows(response.data[1]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(false);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
          const errorInfo = response.data[2];
          // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }
        //setSearch(response.data);
      } else {
        //setRows(null);
        setRows([]);
        setIsLoading(false);
        setWasDataFetchingSuccessful(true);
      }

      //setRows(response.data);
    } catch (error) { 
      if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const hideDialog = () => {
    setErrorDialogVisible(false);
  };
  const tableColumns = [

                    {field:"item_number",
                    header:"Item#"},

                    {field:"ecommerce_flag",
                    header:"EcommFlag"},

                    {field:"sales_channel",
                    header:"Sales Type"},

                    {field:"ship_to_state",
                    header:"State"},

                    {field:"shipment_quantity",
                    header:"Ship Qty"},

                    {field:"shipment_quantity_uom",
                    header:"UOM"},

                    {field:"gross_weight_lb",
                    header:"Gross Weight(LB)"},

                    {field:"gross_volume",
                    header:"Gross Vol"},

                    {field:"gross_volume_cm",
                    header:"Gross Vol CM"}
      ]
      const formatValue = (field, value) => {
          switch (field) {
            case 'shipment_quantity' :
              return numeral(value).format("0,0");
            case 'gross_weight_lb' :
              return numeral(value).format("0.00");
            case 'gross_volume' :
              return  numeral(value).format("0.00");
            case 'gross_volume_cm' :
              return numeral(value).format("0.0000");
            default:
              return value ?? '';
          }
        }
  const exportCSV = () => {
      dt.current.exportCSV();
  };

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
           const headers = tableColumns.map(col=>col.header);
          const dataRows = rows.map((row)=>
          tableColumns.map((col)=>formatValue(col.field, row[col.field])))
           const fullSheetData = [
              [`Organization : ${orgName === "203" ? 'SMG' : orgName === "2" ? 'LD' : ''}`],
              [`State : ${orgCode.value}`],
              [`Start Date : ${startDate}`],
              [`End Date: ${endDate}`],
              [],
              headers,
              ...dataRows
           ]
           const worksheet = xlsx.utils.aoa_to_sheet(fullSheetData)
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'ShipmentSummary');
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };


  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Customer Shipment Data for Audit (Summary Report)</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getLoadedHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="header-container">
        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
         Customer Shipment Data for Audit (Summary Report)
              {/* <div className="header-container p-1">
              <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
          <span className="p-input-icon-right w-full md:w-auto"> 
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto text-sm p-3"
          style={{ fontSize: '17px' }} 
        />
      </span>
          </div> */}
          </h2>
        </div>
      </React.Fragment>
    );
  };
  const getErrrorMsgContents = () => {
    return (
      <React.Fragment>
        <div class="row mt-5 justify-content-md-center">
          <div class="col-3">
            <div class="card border-secondary">
              <div class="card-header bg-dark text-white">
                Customer Shipment Data for Audit (Summary Report) table is Unavailable
              </div>
              <div class="card-body card-body-error rounded-bottom">
                <ul>
                  {loadingErrors.map((error) => (
                    <li>error</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const getSearchControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline"
        />
      </div>
    </React.Fragment>
  );

  const handleListChange = (selectedOption) => {
    setOrgCode(selectedOption);
  }

  const getcodeControl = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Ship To State Code</label>
         <Select
            // className="form-select"
            id="codeId"
            name="codeName"
            onChange={handleListChange}
            options={code}
            value={orgCode}
            placeholder="Select Code"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown1"
            classNamePrefix="select-dropdown1"
          />
      </div>
    </React.Fragment>
  );

  const getStartEndDateControls = () => (
    <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Start Date</label>
        <div className="input-group date input-wrapper">
        <input
          type="date"
          id="StartDateTime"
          name="StartDateTime"
          value={startDate}
          onChange={handleStartDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">End Date</label>
        <div className="input-group date input-wrapper">
        <input
          type="date"
          id="EndDateTime"
          name="EndDateTime"
          value={endDate}
          onChange={handleEndDateChange}
          disabled={isLoading}
          className="input-outline1"
        />
        </div>
      </div>
    </React.Fragment>
  );

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
    const handleRadioChange = (e) => {
    setOrgName(e.target.value); 
  };
    const getOrganizationControl = () => (
      <React.Fragment>
        <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
          <label className="form-label mb-3">Organization</label>
          <div className="d-flex align-items-center">
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                id="org_smg"
                name="orgName"
                value="203"
                checked={orgName === "203"}
                disabled={isLoading}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="org_smg">
                SMG
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="org_ld"
                name="orgName"
                value="2"
                checked={orgName === "2"}
                disabled={isLoading}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="org_ld">
                LD
              </label>
            </div>
          </div>
        </div>
      </React.Fragment>
    );

  const getGoButtonControl = () => (
    <React.Fragment>
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'31px'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={handleLoadData}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
    </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="flex align-items-center justify-content-start gap-2">
        <Button type="button" icon="pi pi-file" rounded onClick={exportCSV} data-pr-tooltip="CSV" tooltip="CSV" tooltipOptions={{ position: "bottom" }} />
        <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" tooltip="XLS" tooltipOptions={{ position: "bottom" }}/>
      </div>
    </div>
  );

  const shipDateTemplate = (rowData) => {
       return rowData.ship_confirm_date ? moment.utc(rowData.ship_confirm_date).format("YYYY-MM-DD") : null;
    };
    const arrivalDateTemplate = (rowData) => {
      return rowData.estimated_arrival_date ? moment.utc(rowData.estimated_arrival_date).format("YYYY-MM-DD") : null;
    };

  const shipQtyTemplate = (rowData) => {
    return numeral(rowData.shipment_quantity).format("0,0");
  };
  const grossWeightTemplate = (rowData) => {
    return numeral(rowData.gross_weight_lb).format("0.00");
  };
  const grossVolumeTemplate = (rowData) => {
    return numeral(rowData.gross_volume).format("0.00");
  };
  const grossVolumeCmTemplate = (rowData) => {
    return numeral(rowData.gross_volume_cm).format("0.0000");
  };

   const fetchdetails = async (item_number, ecommerce_flag) => {
     setItemNumber(item_number);
     setEcommerceFlag(ecommerce_flag);
      setIsLoading1(true);
      const p_param = {
      p_org_id: orgName,
      p_ship_to_state_code: orgCode.value,
      p_start_date: startDate,
      p_end_date: endDate,
      p_item_number: item_number,
      p_ecommerce_flag: ecommerce_flag
      };
      console.log(p_param);
      try {
        const response = await loadApi(
          p_param,
          "api/shipAuditData/getShipAuditDataDtl"
        );
        console.log("Fetched Audit Details:", response.data);
  
        if (response.data.length > 0) {
          const successFlag = response.data[0];
          if (successFlag === "Y") {
            setDetails((prevdetails) => ({
              ...prevdetails,
              [item_number]: response.data[1],
            }));
            setIsLoading1(false);
          } else {
            setDetails((prevdetails) => ({
              ...prevdetails,
              [item_number]: [],
            }));
          }
        } else {
          setDetails((prevdetails) => ({ ...prevdetails, [item_number]: [] }));
          setIsLoading1(false);
        }
      } catch (error) {
        console.error("Error fetching details:", error);
      } finally {
        setIsLoading1(false);
      }
    };
  
    const fetchedIdsRef = useRef(new Set());
  
    useEffect(() => {
      expandedRowId.forEach((item_number) => {
        if(!fetchedIdsRef.current.has(item_number)) {
          const row = rows.find((r)=>r.item_number === item_number)
          if(row){
          fetchdetails(item_number, row.ecommerce_flag);
          fetchedIdsRef.current.add(item_number);
        }
      }
      });
    }, [expandedRowId])

    const fetchComponents = async (item_number, shipment_quantity, organization_id) => {
      setItemNumber(item_number);
      setshipmentQuantity(shipment_quantity);
      setIsLoading2(true);
      const p_param = {
      p_organization_id: organization_id,
      p_parent_item_number: item_number,
      p_parent_quantity: shipment_quantity
      };
      console.log(p_param);
      try {
        const response = await loadApi(
          p_param,
          "api/shipAuditData/getComponentInfo"
        );
        console.log("Fetched Components:", response.data);
  
        if (response.data.length > 0) {
          const successFlag = response.data[0];
          if (successFlag === "Y") {
            setComponents((prevcomponents) => ({
              ...prevcomponents,
              [item_number]: response.data[1],
            }));
            setIsLoading2(false);
          } else {
            setComponents((prevcomponents) => ({
              ...prevcomponents,
              [item_number]: [],
            }));
          }
        } else {
          setComponents((prevcomponents) => ({ ...prevcomponents, [item_number]: [] }));
          setIsLoading2(false);
        }
      } catch (error) {
        console.error("Error fetching components:", error);
      } finally {
        setIsLoading2(false);
      }
    };
  
    const fetchedIdsRef1 = useRef(new Set());
  
    useEffect(() => {
      expandedRowId1.forEach((item_number) => {
        if(!fetchedIdsRef1.current.has(item_number)) {
          const row = rows.find((r)=>r.item_number === item_number)
          if(row){
          fetchComponents(item_number, row.shipment_quantity, row.organization_id);
          fetchedIdsRef1.current.add(item_number);
        }
      }
      });
    }, [expandedRowId1])
   
  
    const drillDownTemplateA = (rowData) => {
      const isExpandedA = expandedRowId.includes(rowData.item_number);
      const isExpandedB = expandedRowId1.includes(rowData.item_number);
      const isExpanded = isExpandedA && !isExpandedB;
  
      return (
        <Button
          icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
          className={`p-button-rounded p-button-sm ${
            isExpanded ? "p-button-danger" : "p-button-primary"
          }`}
          onClick={() => toggleRowExpansion(rowData.item_number, 'A')}
          tooltip="Detail"
          tooltipOptions={{ position: "bottom" }}
          style={{ fontSize: "1rem" }}
        />
      );
    };

    const drillDownTemplateB = (rowData) => {
      const isExpandedA = expandedRowId.includes(rowData.item_number);
      const isExpandedB = expandedRowId1.includes(rowData.item_number);
      const isExpanded = !isExpandedA && isExpandedB;
  
      return (
        <Button
          icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
          className={`p-button-rounded p-button-sm ${
            isExpanded ? "p-button-danger" : "p-button-primary"
          }`}
          onClick={() => toggleRowExpansion(rowData.item_number, 'B')}
          tooltip="Comp Detail"
          tooltipOptions={{ position: "bottom" }}
          style={{ fontSize: "1rem" }}
        />
      );
    };
  
    const toggleRowExpansion = (rowId, type) => {
      if(type === 'A'){
      setExpandedRowId((prevExpandedRowId) =>
        prevExpandedRowId.includes(rowId)
          ? prevExpandedRowId.filter((id) => id !== rowId)
          : [...prevExpandedRowId, rowId]
      );
      setExpandedRowId1((prevExpandedRowId1)=>prevExpandedRowId1.filter((id)=>id !== rowId))
    } else if(type === 'B'){
      setExpandedRowId1((prevExpandedRowId) =>
        prevExpandedRowId.includes(rowId)
          ? prevExpandedRowId.filter((id) => id !== rowId)
          : [...prevExpandedRowId, rowId]
      );
       setExpandedRowId((prevExpandedRowId2)=>prevExpandedRowId2.filter((id)=>id !== rowId))
    }
    };

    console.log("Expanded Row 1", expandedRowId)
     console.log("Expanded Row 2", expandedRowId1)

    const rowExpansionTemplateA = (data) => {
      const tableColumns1 = [

                    {field:"ship_confirm_date",
                    header:"Ship Date"},

                    {field:"estimated_arrival_date",
                    header:"Cust Arrival Date"},

                    {field:"delivery_number",
                    header:"Delivery#"},

                    {field:"order_number",
                    header:"Order#"},

                    {field:"item_number",
                    header:"Item#"},

                    {field:"ecommerce_flag",
                    header:"EcommFlag"},

                    {field:"sales_channel",
                    header:"Sales Type"},

                    {field:"ship_to_city",
                    header:"Ship To City"},

                    {field:"ship_to_state",
                    header:"State"},

                   { field:"ship_to_zip",
                    header:"Zip"},

                   { field:"shipment_quantity",
                    header:"Ship Qty"},

                    {field:"shipment_quantity_uom",
                    header:"UOM"},

                    {field:"gross_weight_lb",
                    header:"Gross Weight(LB)"},

                    {field:"gross_volume",
                    header:"Gross Vol"},

                    {field:"gross_volume_cm",
                    header:"Gross Vol CM"}
      ]
      const formatValue1 = (field, value) => {
          switch (field) {
            case 'ship_confirm_date' :
              return value ? moment.utc(value).format("YYYY-MM-DD") : null;
            case 'arrivalDateTemplate' :
              return value ? moment.utc(value).format("YYYY-MM-DD") : null;
            case 'shipment_quantity' :
              return numeral(value).format("0,0");
            case 'gross_weight_lb' :
              return numeral(value).format("0.00");
            case 'gross_volume' :
              return  numeral(value).format("0.00");
            case 'gross_volume_cm' :
              return numeral(value).format("0.0000");
            default:
              return value ?? '';
          }
        }

    const detailData = details[data.item_number] || [];
      const exportCSV1 = () => {
        dt1.current.exportCSV();
      };

    const exportExcel1 = () => {
        import('xlsx').then((xlsx) => {
          const headers = tableColumns1.map(col=>col.header);
          const dataRows = detailData.map((row)=>
          tableColumns1.map((col)=>formatValue1(col.field, row[col.field])))
           const fullSheetData = [
              [`Organization : ${orgName === "203" ? 'SMG' : orgName === "2" ? 'LD' : ''}`],
              [`State : ${orgCode.value}`],
              [`Start Date : ${startDate}`],
              [`End Date: ${endDate}`],
              [`Item#: ${itemNumber}`],
              [`Ecommerce Flag: ${ecommerceFlag}`],
              [],
              headers,
              ...dataRows
           ]
           const worksheet = xlsx.utils.aoa_to_sheet(fullSheetData)
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile1(excelBuffer, 'ShipmentSummDetail');
        });
    };

    const saveAsExcelFile1 = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };
  
      return (
        <div className="p-3">
          {isLoading1 && (<h6>The data is loading...</h6>)}
          {!isLoading1 && (<>
          <div className="header-container">
            <div className="header-container p-1">
              <style>
                {`
                  input::placeholder {
                    font-size: 17px;
                  }
                `}
              </style>
              <span className="p-input-icon-right w-full md:w-auto">
                <InputText
                  type="search"
                  onInput={(e) => setGlobalFilter1(e.target.value)}
                  placeholder="Search..."
                  className="w-full lg:w-auto text-sm p-3"
                  style={{ fontSize: "17px" }}
                />
              </span>
              <span>
              <Button type="button" icon="pi pi-file" rounded onClick={exportCSV1} data-pr-tooltip="CSV" tooltip="CSV" tooltipOptions={{ position: "bottom" }} style={{marginLeft: "20px", marginBottom: "10px"}} />
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel1} data-pr-tooltip="XLS" style={{marginLeft: "20px", marginBottom: "10px"}} tooltip="XLS" tooltipOptions={{ position: "bottom" }} />
              </span>
              <span style={{marginLeft: "20px"}}>
                <b>No. of Rows :</b> {detailData.length}
              </span>
            </div>
          </div>
          <DataTable
            ref={dt1}
            value={detailData}
            responsiveLayout="scroll"
            globalFilter={globalFilter1}
          >
                  <Column
                    field="ship_confirm_date"
                    header="Ship Date"
                    body={shipDateTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="estimated_arrival_date"
                    header="Cust Arrival Date"
                    body={arrivalDateTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="delivery_number"
                    header="Delivery#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="order_number"
                    header="Order#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="item_number"
                    header="Item#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ecommerce_flag"
                    header="EcommFlag"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                   <Column
                    field="sales_channel"
                    header="Sales Type"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_city"
                    header="Ship To City"
                    sortable
                     style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_state"
                    header="State"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_zip"
                    header="Zip"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="shipment_quantity"
                    header="Ship Qty"
                    body={shipQtyTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="shipment_quantity_uom"
                    header="UOM"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="gross_weight_lb"
                    header="Gross Weight(LB)"
                    body={grossWeightTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="gross_volume"
                    header="Gross Vol"
                    body={grossVolumeTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="gross_volume_cm"
                    header="Gross Vol CM"
                    body={grossVolumeCmTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                </DataTable>
          </>
          )}
        </div>
      );
    }

    const rowExpansionTemplateB = (data) => {
    const componentData = components[data.item_number] || [];
      const seqTemplate = (rowData) => {
        return numeral(rowData.item_seq_num).format("0,0");
      };
      const parentTemplate = (rowData) => {
        return numeral(rowData.parent_quantity).format("0,0");
      };
      const componentTemplate = (rowData) => {
        return numeral(rowData.component_quantity).format("0,0");
      };  
    const tableColumns2 = [

                    {field:"item_seq_num",
                    header:"Seq#"},
                   
                    {field:"comp_item_number",
                    header:"Comp Item#"},
                   
                    {field:"comp_item_descriptipn",
                    header:"Comp Item Desc"},
                    
                    {field:"comp_item_type_mean",
                    header:"Comp Item Type"
                    },
                   { field:"comp_status",
                    header:"Comp Status"
                    },
                    {field:"comp_uom",
                    header:"Comp UOM"},
                    
                    {field:"parent_quantity",
                    header:"Parent Qty"},
                    
                    {field:"component_quantity",
                    header:"Comp Qty"},
                    ]
      const formatValue2 = (field, value) => {
          switch (field) {
            case 'item_seq_num' :
              return numeral(value).format("0,0");
            case 'parent_quantity' :
              return numeral(value).format("0,0");
            case 'component_quantity' :
              return numeral(value).format("0,0");
            default:
              return value ?? '';
          }
        }   
      const exportCSV2 = () => {
        dt2.current.exportCSV();
      };

    const exportExcel2 = () => {
        import('xlsx').then((xlsx) => {
          const headers = tableColumns2.map(col=>col.header);
          const dataRows = componentData.map((row)=>
          tableColumns2.map((col)=>formatValue2(col.field, row[col.field])))
           const fullSheetData = [
              [`Organization : ${orgName === "203" ? 'SMG' : orgName === "2" ? 'LD' : ''}`],
              [`Parent Item# : ${itemNumber}`],
              [`Parent Quantity : ${shipmentQuantity}`],
              [],
              headers,
              ...dataRows
           ]
           const worksheet = xlsx.utils.aoa_to_sheet(fullSheetData)
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile2(excelBuffer, 'ShipmentSummComponent');
        });
    };

    const saveAsExcelFile2 = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };       
  
      return (
        <div className="p-3">
          {isLoading2 && (<h6>The data is loading...</h6>)}
          {!isLoading2 && (<>
          <div className="header-container">
            <div className="header-container p-1">
              <style>
                {`
                  input::placeholder {
                    font-size: 17px;
                  }
                `}
              </style>
              <span className="p-input-icon-right w-full md:w-auto">
                <InputText
                  type="search"
                  onInput={(e) => setGlobalFilter2(e.target.value)}
                  placeholder="Search..."
                  className="w-full lg:w-auto text-sm p-3"
                  style={{ fontSize: "17px" }}
                />
              </span>
              <Button type="button" icon="pi pi-file" rounded onClick={exportCSV2} data-pr-tooltip="CSV" tooltip="CSV" tooltipOptions={{ position: "bottom" }} style={{marginLeft: "20px", marginBottom: "10px"}} />
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel2} data-pr-tooltip="XLS" style={{marginLeft: "20px", marginBottom: "10px"}} tooltip="XLS" tooltipOptions={{ position: "bottom" }} />
              <span style={{marginLeft: "20px"}}>
                <b>No. of Rows :</b> {componentData.length}
              </span>
            </div>
          </div>
          <DataTable
            ref={dt2}
            value={componentData}
            responsiveLayout="scroll"
            globalFilter={globalFilter2}
          >
                  <Column
                    field="item_seq_num"
                    header="Seq#"
                    body={seqTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="comp_item_number"
                    header="Comp Item#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="comp_item_descriptipn"
                    header="Comp Item Desc"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="comp_item_type_mean"
                    header="Comp Item Type"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="comp_status"
                    header="Comp Status"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="comp_uom"
                    header="Comp UOM"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                   <Column
                    field="parent_quantity"
                    header="Parent Qty"
                    body={parentTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="component_quantity"
                    header="Comp Qty"
                    body={componentTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                </DataTable>
          </>
          )}
        </div>
      );
    }
    
  
    const rowExpansionTemplate = (data) => {
      if(expandedRowId.includes(data.item_number)){
        return rowExpansionTemplateA(data);
      }
      else if(expandedRowId1.includes(data.item_number)){
        return rowExpansionTemplateB(data);
      }
    };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {getLoadedHeaderContents()}
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getSearchControls()}
              {getOrganizationControl()}
              {getcodeControl()}
              {getStartEndDateControls()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
                {/* <div className="text-3xl text-800 font-bold mb-4">Customer Shipment Data for Audit (Summary Report)</div> */}
                <DataTable
                  ref={dt}
                  value={rows}
                  scrollable scrollHeight="flex"     
                  selection={selectedRows}
                  onSelectionChange={(e) => setSelectedRows(e.value)}
                  dataKey="item_number"
                  className="custom-datatable-border"
                  tableStyle={{ minWidth: '50rem' }}
                  paginator
                  rows={pageRows}
                  rowsPerPageOptions={rowsPerPageOptions}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
                  globalFilter={globalFilter}
                  header={header}
                  emptyMessage="No data found"
                  stripedRows
                  showGridlines
                  expandedRows={rows.filter(
                    row => expandedRowId.includes(row.item_number) || expandedRowId1. includes(row.item_number)
                  )}
                  rowExpansionTemplate={rowExpansionTemplate}
                  responsiveLayout="scroll"
                  rowExpansion
                > 
                  <Column
                    header="Dtl"
                    body={drillDownTemplateA}
                    style={{ width: "3rem", textAlign: "center" }}
                  />
                  <Column
                    header="Comp"
                    body={drillDownTemplateB}
                    style={{ width: "3rem", textAlign: "center" }}
                  />            
                  <Column
                    field="item_number"
                    header="Item#"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ecommerce_flag"
                    header="EcommFlag"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="sales_channel"
                    header="Sales Type"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="ship_to_state"
                    header="State"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="shipment_quantity"
                    header="Ship Qty"
                    body={shipQtyTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="shipment_quantity_uom"
                    header="UOM"
                    sortable
                    style={{ whiteSpace: "nowrap" }}
                  ></Column>
                  <Column
                    field="gross_weight_lb"
                    header="Gross Weight(LB)"
                    body={grossWeightTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="gross_volume"
                    header="Gross Vol"
                    body={grossVolumeTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                  <Column
                    field="gross_volume_cm"
                    header="Gross Vol CM"
                    body={grossVolumeCmTemplate}
                    sortable
                    style={{ whiteSpace: "nowrap", textAlign: "right" }}
                  ></Column>
                </DataTable>
              </div>
            )}
          </div>
        </div>
             <Dialog 
                 header="API Error" 
                 visible={errorDialogVisible} 
                 style={{ width: '400px' }} 
                 onHide={hideDialog} 
                 footer={
                     <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                 }
             >    
              <p>
 
                     {errorMessage}
                 </p>
             </Dialog>
             </div>
    </div>
  );
};

export default ShipmentSummary;